import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ImageLoaderDirective } from '@pt/directives';

import { ArticleCardSmallComponent } from './article-card-small.component';

@NgModule({
  declarations: [ArticleCardSmallComponent],
  imports: [CommonModule, ImageLoaderDirective],
  exports: [ArticleCardSmallComponent],
})
export class ArticleCardSmallModule {
}
